// 3rd party
import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material';
import { Http, RequestOptions, Headers } from '@angular/http';

@Component({
  selector: 'app-customer-status-dialog',
  templateUrl: './customer-status-dialog.component.html',
  styleUrls: ['./customer-status-dialog.component.css']
})
export class CustomerStatusDialogComponent implements OnInit {

  approveContact: string;
  approveDate: string;
  public calibrationList: any[] = [];
  public isReadOnly: boolean = false;
  isValid: boolean = true;
  loading: boolean = false;
  selectedStatus: number = -1;
  statusDescription: string = '';
  statusList: any[] = [
    { id: 0, name: 'Translate.None' },
    { id: 1, name: 'Translate.Approved' },
    { id: 2, name: 'Translate.Disapproved' },
    { id: 3, name: 'Translate.ApprovedWithReservation' }
  ];

  constructor(
    public dialogRef: MatDialogRef<CustomerStatusDialogComponent>,
    public http: Http
  ) { }

  ngOnInit() {
    this.load();
  }

  load() {
    if (this.isReadOnly && this.calibrationList[0]) {
      let calibration = this.calibrationList[0];
      this.selectedStatus = calibration ? calibration.CustomerStatus : 0;
      this.statusDescription = calibration.CustomerStatusDescription;
      this.approveContact = calibration.ApproveContact ? calibration.ApproveContact.Name : '';
      this.approveDate = calibration.CustomerApproveDate;
    }
  }

  save() {
    this.loading = true;
    const identifiers = this.calibrationList.map((c) => c.Identifier);
    let body = JSON.stringify({ status: this.selectedStatus, description: this.statusDescription, identifiers: identifiers });
    let authorization = 'Bearer ' + localStorage.getItem('token');
    let options = new RequestOptions();
    options.headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': authorization });
    this.http
      .put('calibrations/status', body, options)
      .subscribe((data) => {
        this.loading = false;
        this.dialogRef.close();
      }, err => {
        this.loading = false;
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/calibrations/customer-status-dialog/customer-status-dialog.component.ts